var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionnaire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.81 11.82",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.24-3.12a.22.22 0 01-.24-.22 1 1 0 00-1-1 1 1 0 00-1 1 .22.22 0 01-.22.22H9v1h4.14v-1zm-1.18.23a.42.42 0 01-.41-.41.41.41 0 01.41-.41.41.41 0 01.41.41.41.41 0 01-.41.41z",
    transform: "translate(-7.16 4.3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.56-2.77v.84a.21.21 0 01-.21.21H8.78a.21.21 0 01-.21-.21v-.84H7.16V7.51H15V-2.77zm-3.47 7.94L9.24 6a.27.27 0 01-.36 0l-.43-.44a.22.22 0 01-.07-.17.23.23 0 01.07-.18.25.25 0 01.18-.08.25.25 0 01.18.08l.25.25.67-.68a.27.27 0 01.36 0 .27.27 0 01.08.18.25.25 0 01-.08.21zm0-2.68l-.85.85a.24.24 0 01-.36 0l-.43-.43a.25.25 0 01.18-.43.24.24 0 01.18.07l.25.25.67-.67a.25.25 0 01.36 0 .24.24 0 010 .36zm0-2.68l-.85.85a.27.27 0 01-.36 0L8.45.23a.24.24 0 01-.07-.18.24.24 0 01.07-.18.25.25 0 01.18-.08.25.25 0 01.18.08l.25.25.67-.67a.25.25 0 01.36 0 .23.23 0 01.08.18.27.27 0 01-.08.18zM13 5.67h-2.15a.25.25 0 010-.5H13a.25.25 0 010 .5zM13.6 3h-2.75a.25.25 0 010-.5h2.75a.25.25 0 110 .5zm0-2.68h-2.75A.25.25 0 0110.6.1a.26.26 0 01.25-.26h2.75a.26.26 0 01.26.26.26.26 0 01-.26.25z",
    transform: "translate(-7.16 4.3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaire);
export default __webpack_public_path__ + "static/media/questionnaire.cc08c445.svg";
export { ForwardRef as ReactComponent };